module.exports = __webpack_public_path__ + "img/beep.261236b9.png";